import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FunctionsService } from '../../_LOGIC/__common/functions.service';

@Component({
  selector: 'app-services-page',
  templateUrl: './services-page.component.html',
  styleUrls: ['./services-page.component.css']
})
export class ServicesPageComponent implements OnInit {

  routes = [];
  @ViewChild('packsoffer') packsoffer: ElementRef<HTMLDivElement>;
  @ViewChild('services') services: ElementRef<HTMLDivElement>;

  constructor(private router: Router,private commonFunctions: FunctionsService,private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    let ruta = this.activatedRoute.snapshot.pathFromRoot
    // Mapear cada segmento de la ruta
    .map(v => v.url.map(segment => this.routes.push(segment)))
    // Filtrar segmentos vacíos
    .filter(v => v);
    
    if(this.routes[0] && this.routes[0] == 'services'){
      if(this.routes[1]){
        if(this.routes[1] == 'testimonial'){
          this.scrollToElement('testimonial');
        }
        if(this.routes[1] == 'packs'){
          this.scrollToElement('packsoffer');
        }
      }else{
        this.commonFunctions.scrollToTop();
        /* this.scrollToElement('services'); */
      }
    }
  }

  goToPage(page){
    this.router.navigateByUrl(page);
  }

  goToCalendly(){
    this.commonFunctions.goToCalendly();
  }

  scrollToElement(label): void {

    switch(label){
      case 'packsoffer':
        if (this.packsoffer && this.packsoffer.nativeElement) {
          this.packsoffer.nativeElement.scrollIntoView({ behavior: 'smooth'});
        }
        break;
      case 'services':
        if (this.services && this.services.nativeElement) {
          this.services.nativeElement.scrollIntoView({ behavior: 'smooth'});
        }
        break;
    }
  }

  

}
